import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { Urls } from 'kts-platform-frame/entry/constant';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import IData from './IData';
import IOptions from './IOptions';

/**
 * SecurityMgrUnlock
 */
class SecurityMgrUnlock extends ApiBasic<IOptions, IData> {

    /** 入口 */
    public async api(option: IOptions): Promise<Response<IData>> {

        const req: Request = new Request(CallType.POST, Urls.USER_SECURITY_MGR_UNLOCK, option);

        let data: Response<IData> = await this.callAjax(req);

        return data;
    }
}

export default new SecurityMgrUnlock().run;



// WEBPACK FOOTER //
// ./src/api/systemManage/userManage/SecurityMgrUnlock/index.ts